"use strict";
import React from "react";

import MyRoutes from "./router/routers";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./api/firebase.ts";
import ButtonLoading from "./components/ButtonLoading";
import zIndex from "@mui/material/styles/zIndex.js";
import { colors } from "./assets/colors";
import ProjectsProvider from "./contexts/ProjectsContext";
import UserProvider from "./contexts/UserContext";

const mdTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: "#ECF1FE",
    },
  },
  typography: {
    fontFamily: ["Poppins"].join(","),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('Poppins'), local('Poppins-Regular'), format('ttf');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

const bugButtonStyle: React.CSSProperties = {
  fontSize: 26,
  zIndex: zIndex.modal + 1,
  position: "fixed" as "fixed",
  right: 20,
  bottom: 20,
  width: 10,
  height: 60,
  borderRadius: 100,
  backgroundColor: colors.status.red,
  color: colors.white,
};

const openBugForm = () => {
  window.open("https://forms.gle/kwS2MbiSWjbe6Pqm8", "_blank");
};

function App() {
  return (
    <ThemeProvider theme={mdTheme}>
      <UserProvider>
        <ProjectsProvider>
          <ButtonLoading
            label="🐞"
            style={bugButtonStyle}
            onClick={openBugForm}
          />
          <MyRoutes />
          <ToastContainer position="top-right" autoClose={5000} />
        </ProjectsProvider>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
